<template>
    <div>
        <div class="d-flex justify-content-center mb-4 mt-2">
            <span class="icon icon-glyphicons-basic-power-cord-plug mr-2" style="font-size: 60px"></span>
        </div>
        <div v-if="organizationLMSFeatureEnabled">
            <p class="text-center mb-4">You haven't set up any LMS integrations yet.</p>
            <div class="d-flex justify-content-center medium mb-4">
                <router-link
                    v-if="userIsOrganizationAdmin"
                    :to="{ name: 'LMSIntegrationSettings' }"
                    class="btn btn-primary"
                    data-dismiss="modal"
                    >Add an LMS Integration</router-link
                >
                <span v-else>Contact your administrator to set up an integration with your LMS.</span>
            </div>
        </div>
        <div v-else>
            <p class="font-weight-500 text-center mb-3">You haven't set up any LMS integrations yet.</p>
            <p class="text-center medium mb-3">
                To set up an LMS integration, contact us at <a href="mailto:team@affinitylearning.ca?subject=LMS Integration"
                    >team@affinitylearning.ca</a
                >.
            </p>
            <p class="text-center medium mb-4">
                Alternatively, you can
                <router-link :to="{ name: 'Pages' }" data-dismiss="modal">create a Landing Page</router-link>.
            </p>
        </div>
        <support-request-prompt class="text-center mb-3" />
        <billing-view ref="billingView"></billing-view>
    </div>
</template>

<script>
import BillingView from "@/components/BillingView"
import SupportRequestPrompt from "@/components/SupportRequestPrompt"

export default {
    name: "LtiNotConfigured",
    components: {
        BillingView,
        SupportRequestPrompt,
    },
    computed: {
        organizationLMSFeatureEnabled() {
            return this.$store.getters.organizationDetails.ff_lms_integration
        },
        organizationBillingEnabled() {
            return this.$store.getters.organizationBillingEnabled
        },
        userIsOrganizationAdmin() {
            return this.$store.getters.userIsOrganizationAdmin
        },
    },
}
</script>

<style>
</style>